var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 11.6666C5.33301 11.3905 5.55687 11.1666 5.83301 11.1666H14.833C15.1091 11.1666 15.333 11.3905 15.333 11.6666C15.333 11.9428 15.1091 12.1666 14.833 12.1666H5.83301C5.55687 12.1666 5.33301 11.9428 5.33301 11.6666Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 7.66663C5.33301 7.39048 5.55687 7.16663 5.83301 7.16663H14.833C15.1091 7.16663 15.333 7.39048 15.333 7.66663C15.333 7.94277 15.1091 8.16663 14.833 8.16663H5.83301C5.55687 8.16663 5.33301 7.94277 5.33301 7.66663Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 3.66663C5.33301 3.39048 5.55687 3.16663 5.83301 3.16663H14.833C15.1091 3.16663 15.333 3.39048 15.333 3.66663C15.333 3.94277 15.1091 4.16663 14.833 4.16663H5.83301C5.55687 4.16663 5.33301 3.94277 5.33301 3.66663Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 4.66663C2.88529 4.66663 3.33301 4.21891 3.33301 3.66663C3.33301 3.11434 2.88529 2.66663 2.33301 2.66663C1.78072 2.66663 1.33301 3.11434 1.33301 3.66663C1.33301 4.21891 1.78072 4.66663 2.33301 4.66663Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 8.66663C2.88529 8.66663 3.33301 8.21891 3.33301 7.66663C3.33301 7.11434 2.88529 6.66663 2.33301 6.66663C1.78072 6.66663 1.33301 7.11434 1.33301 7.66663C1.33301 8.21891 1.78072 8.66663 2.33301 8.66663Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 12.6666C2.88529 12.6666 3.33301 12.2189 3.33301 11.6666C3.33301 11.1143 2.88529 10.6666 2.33301 10.6666C1.78072 10.6666 1.33301 11.1143 1.33301 11.6666C1.33301 12.2189 1.78072 12.6666 2.33301 12.6666Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscList);
export default __webpack_public_path__ + "static/media/discList.dc4c775b254a7cd333026322b709b745.svg";
export { ForwardRef as ReactComponent };